/**
 * created by HY
 * 新媒体-宣传阵地管控-阵地管理-内容录入编辑器
 */
import React, { PureComponent, createRef } from 'react';
import { Button, message } from 'antd';
import Editor from '../Editor';
import { EditorInformationOfWebEditor as EditorInformation } from './components/EditorInformationOfWebEditor';
import {systemBaseEvent} from "../../../base/baseEvent";
import BaseComponent from '../../../base/BaseComponent';
import IconFont from '../../components/svgIcon/IconFont';
import svgList from '../components/image/svgList';
import WordImport from './components/wordImport';
import { uuid } from '../../../utils';


class NewMediaContentEntry extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            id: "",
            storyId: "",
            contentText: "",
            informationStatus: false,
        };

        window.ueditor.setCurrentInformation = (data) => {
            this.setCurrentInformation(data);
        };
        this.editorRef = createRef();
        this.wordImpRef = createRef();
    }

    componentDidMount() {
        this.callPostMessage({message: "请求父组件刷新页面"})
    }

    //设置基本信息
    setCurrentInformation(data) {
        this.EditorInformation.setInformation(data)
    }

        //获取基本信息
        getCurrentInformation() {
            let editorInformation = this.EditorInformation.getInformation();
            // if(editorInformation && typeof editorInformation === "object") {
            //     editorInformation["category"] = "contribute";
            // }
            return editorInformation
        }

    // 渲染稿件基本信息
    renderInformation = () => {
        return (
            <EditorInformation
                // 配置文件
                informationConfig={{url: "",showFTitle:false,hideTitleStyleBtn: false}}
                // 配置文件
                formItemSizeConfig={{fontSize: 14,formItemHeight:{default:40}}}
                // 基本信息展开状态
                // informationStatus={this.state.informationStatus||false}
                // 编辑器内容
                contentText={this.state.contentText}
                dynamicParams={{
                    // editorId: this.state.id,
                }}
                formItemOnChange={(key, value)=>{//表单内容变化时通知
                    systemBaseEvent.asyncExec("editorInformationItemChange", {key, value});
                }}
                ref={(EditorInformation) => {
                    this.EditorInformation = EditorInformation;
                    window.ueditor.getInformation = (check) => this.EditorInformation.getInformation(check);
                    // window.ueditor.delAttachByMd5 = (md5) => this.EditorInformation.delAttachByMd5(md5);
                    // window.ueditor.setFocus = (labelKey) => this.EditorInformation.setFocus(labelKey);
                    // window.ueditor.informationSelect = (labelKey,sIndex,eIndex) => this.EditorInformation.selectText(labelKey,sIndex,eIndex);
                }}
            />
        )
    };

     //渲染按钮
    renderActBtn = () => {
        return (
            <div
                id={'btnList'}
                className={'newMedia_content_enter'}
                style={{ height: 64, background: this.themeBgColor, padding: '0 20px', color: '#fff'}}
            >
                <div className={'btnStyle'} style={{cursor: 'pointer'}} onClick={()=>{this.saveStory()}}>
                    <IconFont className={'btnIcon'} type={svgList("rmt_submit")} style={{}}/>
                    <span>确认录入</span>
                </div>
                <div className={'btnStyle'} style={{cursor: 'pointer'}} onClick={()=>{typeof this.wordImpRef.current.wordUpload === "function"&&this.wordImpRef.current.wordUpload()}}>
                    <IconFont className={'btnIcon'} type={svgList("rmt_import")} style={{}}/>
                    <span>word导入</span>
                </div>
                <div className={'btnStyle'} style={{cursor: 'pointer'}} onClick={()=>{window.close()}}>
                    <IconFont className={'btnIcon'} type={svgList("rmt_qiyong")} style={{}}/>
                    <span>关闭</span>
                </div>
                <style>{`.newMedia_content_enter { display: flex; align-items: center; justify-content: flex-start; gap: 10px;}`}</style>
            </div>
        )
    };

    render() {
        return (
            <>
                <Editor
                    ref={this.editorRef}
                    // 动态参数（传递到子组件中）
                    dynamicParams={{
                        // editorId:this.state.id,
                        // oldId:this.urlParams.storyId||this.state.storyId,
                        isShowResource:false,
                    }}
                    // 流程组件
                    editorActBtn={this.renderActBtn()}
                    // 右编按钮
                    staticButtonAreaConfig={[]}
                    // 稿件基本信息组件
                    editorInformation={this.renderInformation()}
                    //稿件基本信息展开图标显示
                    informationStatusShow={false}
                    // 稿件栏目设置模块
                    editorRightModule={<div style={{display: "none"}}></div>}
                    // editorLeftModule={this.renderLeft()}
                    publishSettingStatus={false}
                    pluginsSpaceConfig={[]}
                    pluginsSpaceConfigLeft={[{ oneLineToolSpace: ["pictureTool","videoTool"]}]}
                />
                <WordImport ref={this.wordImpRef} editor={window.ueditor} />
            </>
        )
    }

    //获取编辑器内容
    getEditContent() {
        let contentTxt = this.getEditContentText();
        let content = window.ueditor.getContent();
        if(
            !(contentTxt && contentTxt.length) &&
            !(content.indexOf("img") > -1 || content.indexOf("IMG") > -1|| content.indexOf("iframe") > -1 || content.indexOf("IFRAME") > -1)
        ) {
            return false
        }
        return content
    }

    //获取编辑器内容（文字）
    getEditContentText() {
        return window.ueditor.getContentTxt();
    }

    /**
     * 稿件保存
     */
    saveStory = (call) => {
        message.destroy();
        const loadingKey = uuid();
        // activiti&&activiti.load.start();
        //获取编辑器内容=============start
        let content = this.getEditContent();
        window.loading.show(true,loadingKey)
        if(!content) {
            window.loading.hide(loadingKey);
            message.warning("请填写正文内容！");
            call && call(false);
            return false
        }
        if (content.indexOf("wordimg.png") !== -1) {
            window.loading.hide(loadingKey);
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call && call(false);
            return false
        }
        //获取编辑器内容==================end

        // 获取基础属性==================start
        let currentInformation = this.getCurrentInformation();
        if (!currentInformation) {// 基本信息校验（自带）
            window.loading.hide(loadingKey);
            call && call(false);
            return false
        }
        // if(this.storyData.variableFields){
        //     currentInformation.variableFields.formatId = this.storyData.variableFields.formatId;
        // }
        // let {information, dynamicParams} = currentInformation;
        // 获取基础属性================end
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        let params = {
            ...currentInformation,
            ...this.urlParams,
            titleCover:currentInformation.titlePic,
            content,
        };
        if (id&&id!=='') {
            params.id = id;
        }
        console.log(params,"-----------res------------");
        this.request({
            url: '/cm-sites-media-consumer/position/handler/saveContentEntryStory',
            method: 'POST',
            body: params,
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    this.state.id = res;
                    message.success("暂存成功",1,()=>{
                        this.callPostMessage({message: "请求刷新父页面"});
                    });
                } else {
                    message.error('暂存失败！');
                    call && call(false);
                }
                window.loading.hide(loadingKey);
            },
            errorCallBack: function (e) {
                call && call(false);
                window.loading.hide(loadingKey);
                message.error('暂存失败！');
            },
            serverVerify: {
                serverErrorCallBack: (e,allData) => {
                    window.loading.hide(loadingKey);
                    call && call(false);
                }
            }
        });
    };

}
export default NewMediaContentEntry;